// Top progress ribbon illustrating the walkthrough through the selected models.
import type { BatchModelState } from '../api';

const STATUS_LABEL: Record<string, string> = {
  queued: 'waiting',
  pending: 'queued',
  running: 'running',
  done: 'done',
  error: 'error',
  cancelled: 'cancelled',
};

export default function ModelRibbon({
  models,
  currentIndex,
}: {
  models: BatchModelState[];
  currentIndex: number;
}) {
  return (
    <ol className="ribbon">
      {models.map((m) => {
        const isCurrent = m.index === currentIndex;
        return (
          <li key={m.model} className={`ribbon-step ${m.status}${isCurrent ? ' current' : ''}`}>
            <span className="ribbon-index">{m.index + 1}</span>
            <span className="ribbon-model" title={m.model}>
              {m.model}
            </span>
            <span className="ribbon-status">
              {STATUS_LABEL[m.status] ?? m.status}
              {m.status === 'done' && m.score != null ? ` · ${m.score.toFixed(1)}` : ''}
            </span>
          </li>
        );
      })}
    </ol>
  );
}
